module.exports = __webpack_public_path__ + "static/other/ocean_cleanup.37198c01.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/ocean_cleanup.json
// module id = 2557
// module chunks = 0